import * as Sentry from '@sentry/react';

import { DYNAMIC_IMPORT_ERROR_PREFIXES } from 'client-web-sdk';

import { getHeyloginVersion, getWebappUrl } from './servers';

export default function initSentry() {
  // Only connect in production and staging, which both use production builds. The hostname check
  // excludes review apps, which use the same prod build. Checks the web app's hostname, like
  // client-web does; this app's own host doesn't identify the deployment.
  const prodBuildEnv = import.meta.env.MODE === 'production';
  const { hostname } = new URL(getWebappUrl());
  const prodOrStagingUrl =
    hostname.endsWith('heylogin.app') || hostname.endsWith('staging.heylogin.dev');
  if (!prodBuildEnv || !prodOrStagingUrl) {
    return;
  }

  const environment = hostname === 'heylogin.app' ? 'production' : 'staging';

  try {
    Sentry.init({
      dsn: 'https://37e723cb544735c2eef5090b51ded69e@stackreports.heylogin.app/10',
      release: getHeyloginVersion() || 'unknown version',
      environment,
      // Disable auto session tracking, see https://docs.sentry.io/platforms/javascript/migration/v8-to-v9/#:~:text=To%20disable%20session%20tracking
      integrations: (integrations) => [
        ...integrations.filter((integration) => integration.name !== 'BrowserSession'),
        Sentry.zodErrorsIntegration(),
      ],
      ignoreErrors: [...DYNAMIC_IMPORT_ERROR_PREFIXES],
    });
    if (!getHeyloginVersion()) {
      Sentry.captureMessage(
        'Sentry was initialized in a production build without version information',
      );
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error while initializing error reporting ¯\\_(ツ)_/¯', e);
  }
}
